import { useContext } from 'react';
import { FormContext } from '~/components/forms/FormContext.jsx';
import Modal from '~/components/Modal';
import ThemedForm from '~/components/forms/ThemedForm.jsx';
import { minutesToDuration } from '~/lib/DateTime.js';
import { SelectionImage } from '~/components/forms/questions/components/SelectionBlock.jsx';
import ClassDescription, {
    ClassSpotsLeft,
    ClassTitle,
    isInstanceSelected,
} from '~/components/forms/questions/scheduling/ClassDescription.jsx';
import ClassBookButton from '~/components/forms/questions/scheduling/ClassBookButton.jsx';
import { clientFormatDateTimeLong } from '~/public/lib/ClientDateTime.js';

const ClassViewModal = ({
    isOpen,
    instance,
    onSelect,
    onClose,
    settings,
    onRemoveClass,
    selectedClasses,
    clientTz,
}) => {
    const type = instance?.event_type;
    const { form } = useContext(FormContext);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ThemedForm styles={form?.settings?.styles}>
                {!!instance && (
                    <>
                        <h2>{type?.name}</h2>
                        <div className="text-gray-500 text-center">
                            {clientFormatDateTimeLong(
                                instance?.start,
                                clientTz,
                            )}
                            {!settings?.hideDuration && (
                                <> ({minutesToDuration(type?.duration)})</>
                            )}
                        </div>
                        {!settings?.hideBookableResource && (
                            <div className="text-gray-500 text-center">
                                with {instance?.bookable_resource?.name}
                            </div>
                        )}

                        <div className="flex items-start mt-8">
                            {!!type?.image && (
                                <SelectionImage
                                    image={type?.image}
                                    className="my-0 mt-0"
                                />
                            )}
                            <div>
                                <ClassTitle
                                    type={type}
                                    hideTypeName={true}
                                    settings={settings}
                                />
                                <ClassDescription
                                    instance={instance}
                                    type={type}
                                />
                                <ClassSpotsLeft
                                    instance={instance}
                                    settings={settings}
                                    className="mt-2"
                                />
                            </div>
                        </div>

                        <div className="mt-6 pt-6 border-t -mx-6 text-center">
                            <ClassBookButton
                                isSelected={isInstanceSelected(
                                    instance,
                                    selectedClasses,
                                )}
                                onSelect={() => {
                                    onSelect(instance);
                                    onClose();
                                }}
                                onRemove={() => {
                                    onRemoveClass(instance);
                                    onClose();
                                }}
                                instance={instance}
                                settings={settings}
                            />
                        </div>
                    </>
                )}
            </ThemedForm>
        </Modal>
    );
};

export default ClassViewModal;
